import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'common-tab-with-buttons',
  templateUrl: './tabgroup-buttons.component.html',
  styleUrls: ['./tabgroup-buttons.component.scss'],
})
export class TabGroupButtonsComponent {}
